import React from "react"
import PropTypes from "prop-types"

class DateButton extends React.PureComponent {
  render() {
    const {onClick, value, style} = this.props
    const className = `date-button ${this.props.className ? this.props.className : ""}`
    return (
      <button type="button" className={className} style={style} onClick={onClick}>
        {value}
        <span className="fa fa-calendar-check-o"/>
      </button>
    )
  }
}

DateButton.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default DateButton
